// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

// ** Sources
export const getRequestSourcesList = createAsyncThunk('appRequestSources/getRequestSourcesList', async params => {
   params.page = params.page === 0 ? 0 : params.page - 1
   const response = await axios.post(`https://api.mfauto.com.ua/request-sources/list?env=${process.env.REACT_APP_NODE_ENV}`, {
      ...params,
      token: localStorage.getItem('token')
   })

   return {
      params,
      data: response.data.sources,
      totalPages: response.data.total_elements
   }
})

export const addRequestSource = createAsyncThunk('appRequestSources/addRequestSource', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/request-sources/add?env=${process.env.REACT_APP_NODE_ENV}`, {
      ...data,
      token: localStorage.getItem('token')
   })
   return response.data
})

export const updateRequestSource = createAsyncThunk('appRequestSources/updateRequestSource', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/request-sources/edit?env=${process.env.REACT_APP_NODE_ENV}`, {
      ...data,
      token: localStorage.getItem('token')
   })
   return response.data
})

export const getRequestSource = createAsyncThunk('appRequestSources/getRequestSource', async (id) => {
   const response = await axios.post(`https://api.mfauto.com.ua/request-sources/get?env=${process.env.REACT_APP_NODE_ENV}`, {
      id,
      token: localStorage.getItem('token')
   })
   return response.data
})

export const removeRequestSource = createAsyncThunk('appRequestSources/removeRequestSource', async (id) => {
   const response = await axios.post(`https://api.mfauto.com.ua/request-sources/remove?env=${process.env.REACT_APP_NODE_ENV}`, {
      id,
      token: localStorage.getItem('token')
   })
   return response.data
})

export const addRequestSourceNumber = createAsyncThunk('appRequestSources/addRequestSourceNumber', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/request-sources/numbers/add?env=${process.env.REACT_APP_NODE_ENV}`, {
      ...data,
      token: localStorage.getItem('token')
   })
   return response.data
})

export const editRequestSourceNumber = createAsyncThunk('appRequestSources/editRequestSourceNumber', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/request-sources/numbers/edit?env=${process.env.REACT_APP_NODE_ENV}`, {
      ...data,
      token: localStorage.getItem('token')
   })
   return response.data
})

export const removeRequestSourceNumber = createAsyncThunk('appRequestSources/removeRequestSourceNumber', async (id) => {
   const response = await axios.post(`https://api.mfauto.com.ua/request-sources/numbers/remove?env=${process.env.REACT_APP_NODE_ENV}`, {
      id,
      token: localStorage.getItem('token')
   })
   return response.data
})

export const appRequestSourcesSlice = createSlice({
   name: 'appRequestSources',
   initialState: {
      data: [],
      total: 1,
      params: {},
      selectedSource: null
   },
   reducers: {},
   extraReducers: builder => {
      builder
      .addCase(getRequestSourcesList.fulfilled, (state, action) => {
         state.data = action.payload.data
         state.params = action.payload.params
         state.total = action.payload.totalPages
      })
      .addCase(getRequestSource.fulfilled, (state, action) => {
         state.selectedSource = action.payload
      })
      .addCase(addRequestSourceNumber.fulfilled, (state, action) => {
         if (state.selectedSource) {
            state.selectedSource.numbers = action.payload.numbers
         }
      })
      .addCase(editRequestSourceNumber.fulfilled, (state, action) => {
         if (state.selectedSource) {
            state.selectedSource.numbers = action.payload.numbers
         }
      })
   }
})

export default appRequestSourcesSlice.reducer
